import moment from 'moment'
import 'moment-timezone'
import { parse, isValid, format, differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { Image, ProgressBar } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api.js'
import '../../../css/painelDispositivos/dspSimcard/dspAcoes.css'
import {
  esconderMenuAcoesDispositivosBloqueio,
  mudarManejador,
  mudarOrdenador
} from '../../../redux/actions/index'
import {
  elipseAzul,
  elipseVerde,
  elipseVermelho,
  setaDropdown
} from '../../../utils/alternanciaIcones.js'
import { getColunasClienteNivelN3 } from '../../../utils/colunas.js'
import decryptJWT from '../../../utils/decryptJWT.js'
import { formatarData } from '../../../utils/formatadorDataTabela.js'
import { formatarMilhar } from '../../../utils/formatarMilhar.js'
import { isPortal } from '../../../utils/nivelCliente.js'
import {
  handlerDesativarImagens,
  handleRemoverImagens
} from '../../../utils/ordenacao.js'
import { validadorPermissaoElemento } from '../../../utils/verificadorPermissaoElemento.js'
import ColetaClickstream from '../../clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import { CustomTooltip } from '../../tooltip/index.jsx'

import TabelaSimcard from './tabelaDispositivos/index.jsx'
import verificarColunaDsp from './verificarColuna.js'
import verificarNomeDsp from './verificarNome.js'

let verificadorBloqueioFinanceiro = false

const normalizarValorNull = (valor) => {
  if (valor === null || valor === undefined || valor === 'null' || valor === 'undefined') {
    return null
  }
  if (valor === '0000-00-00 00:00:00' || valor === '0000-00-00') {
    return null
  }
  return valor
}

const isValidValue = (valor) => {
  const normalized = normalizarValorNull(valor)
  return normalized != null && normalized !== ''
}

function ContainerFormatter({ valor, row }) {
  const isClienteBloqueadoOuLinhaInativa =
    verificadorBloqueioFinanceiro || row?.TRAFEGO !== 'Ativo'

  return (
    <p
      className={
        isClienteBloqueadoOuLinhaInativa
          ? 'fonte-cor-7 label-tabela-1'
          : 'fonte-cor-1 label-tabela-1'
      }
      key={row?.CD_SIMCARD}
    >
      {valor}
    </p>
  )
}

function MoneyFormatter(cell, row) {
  const valor = parseFloat(cell)
  const isClienteBloqueadoOuLinhaInativa =
    verificadorBloqueioFinanceiro || row?.TRAFEGO !== 'Ativo'

  return (
    <div
      className={
        isClienteBloqueadoOuLinhaInativa
          ? 'fonte-cor-7 label-tabela-1 container-valor-simcard'
          : 'fonte-cor-1 label-tabela-1 container-valor-simcard'
      }
    >
      {!valor || isNaN(valor) ? (
        'R$ 0.00'
      ) : (
        <>
          <p className="valor-rs-simcard">R$</p>
          <p
            className={
              isClienteBloqueadoOuLinhaInativa
                ? 'fonte-cor-7 valor-simcard'
                : 'fonte-cor-1 valor-simcard'
            }
          >
            {formatarMilhar(valor)}
          </p>
        </>
      )}
    </div>
  )
}

const SpanSemIsChild = (props) => {
  const rest = { ...props }
  delete rest.isChild
  return <span {...rest} />
}

function CarregarColunas(props) {
  let colunaSimcard
  const [colunas, setColunas] = useState([])
  const [render, setRender] = useState(false)
  const [colunasMongo, setColunasMongo] = useState()
  const [colunasMongoFaturas, setColunasMongoFaturas] = useState()
  const [permissaoFaturas, setPermissaoFaturas] = useState()
  let dataFormatada = moment().format('YYYY-MM-DD')

  const despacho = useDispatch()
  let ordenador = useSelector((state) => state.manejadorState.ordenador)
  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )

  async function handlePermissao() {
    setPermissaoFaturas(
      await validadorPermissaoElemento(
        permissaoElemento,
        'veye/dispositivos/colunasFaturas'
      )
    )
  }

  useEffect(() => {
    if (permissaoElemento.length > 0) {
      handlePermissao()
    }
  }, [permissaoElemento])

  async function handlerOrdenador(nomeOrdenador, nomeDiferenciado) {
    ColetaClickstream(187) // 'dspSimcardTabelaSimcardHandlerOrdenador'
    if (decryptJWT('clientePrimario') != 2455) {
      let isItDescrescente = false
      const imagem = document.getElementById(nomeOrdenador + nomeDiferenciado)
      if (
        nomeOrdenador === ordenador.split(' ASC')[0] ||
        nomeOrdenador === ordenador.split(' DESC')[0]
      ) {
        await ordenador.split(' ').map((item_ordenador) => {
          if (
            nomeOrdenador == 'CONSUMO_PERCENTUAL' ||
            nomeOrdenador == 'CONSUMO_MB'
          ) {
            if (item_ordenador === 'ASC') {
              ordenador = ''
              isItDescrescente = false
              handleRemoverImagens(imagem)
            }
            if (item_ordenador === 'DESC') {
              ordenador = nomeOrdenador + ' ASC'
              isItDescrescente = true
              handlerDesativarImagens(imagem, 'DESC')
            }
          } else {
            if (item_ordenador === 'ASC') {
              ordenador = nomeOrdenador + ' DESC'
              isItDescrescente = true
              handlerDesativarImagens(imagem, 'ASC')
            }
            if (item_ordenador === 'DESC') {
              ordenador = ''
              isItDescrescente = false
              handleRemoverImagens(imagem)
            }
          }
        })
      } else if (!isItDescrescente) {
        if (
          nomeOrdenador == 'CONSUMO_PERCENTUAL' ||
          nomeOrdenador == 'CONSUMO_MB'
        ) {
          ordenador = nomeOrdenador + ' DESC'
          handlerDesativarImagens(imagem, 'ASC')
        } else {
          ordenador = nomeOrdenador + ' ASC'
          handlerDesativarImagens(imagem, 'DESC')
        }
      }

      despacho(mudarOrdenador(JSON.parse(JSON.stringify(ordenador))))
    }
  }

  const onDragEnd = async (fromIndex, toIndex) => {
    if (toIndex >= 0) {
      let columnsCopy = []
      let clunasHidden = []
      await Promise.all(
        colunas.map((item_colunas) => {
          if (!item_colunas.hidden && item_colunas.hidden != true) {
            columnsCopy.push(item_colunas)
          } else {
            clunasHidden.push(item_colunas)
          }
        })
      )
      let itemColunaFrom = JSON.parse(JSON.stringify(columnsCopy[fromIndex]))
      let itemColunaTo = JSON.parse(JSON.stringify(columnsCopy[toIndex]))

      const item = columnsCopy.splice(fromIndex, 1)[0]
      columnsCopy.splice(toIndex, 0, item)

      await Promise.all(
        clunasHidden.map((item_clunasHidden) => {
          columnsCopy.push(item_clunasHidden)
        })
      )

      if (itemColunaFrom.ordem > itemColunaTo.ordem) {
        await Promise.all(
          colunasMongo.map((item_colunasMongo) => {
            if (
              itemColunaFrom.ordem > item_colunasMongo.ordem &&
              itemColunaTo.ordem <= item_colunasMongo.ordem
            ) {
              item_colunasMongo.ordem += 1
            }
            if (itemColunaFrom.dataField === item_colunasMongo.id) {
              item_colunasMongo.ordem = itemColunaTo.ordem
            }
          })
        )
      }

      if (itemColunaFrom.ordem < itemColunaTo.ordem) {
        await Promise.all(
          colunasMongo.map((item_colunasMongo) => {
            if (
              itemColunaTo.ordem >= item_colunasMongo.ordem &&
              itemColunaFrom.ordem < item_colunasMongo.ordem
            ) {
              item_colunasMongo.ordem -= 1
            }
            if (itemColunaFrom.dataField === item_colunasMongo.id) {
              item_colunasMongo.ordem = itemColunaTo.ordem
            }
          })
        )
      }

      await Promise.all(
        columnsCopy.map((item_columnsCopy) => {
          colunasMongo.map((item_colunasMongo) => {
            if (item_columnsCopy.dataField === item_colunasMongo.id) {
              item_columnsCopy.ordem = item_colunasMongo.ordem
            }
          })
        })
      )

      await api_gateway.post('/m1/servicos/dados/alterar_colunas_simcard', {
        email: decryptJWT('email'),
        colunas: colunasMongo,
        colunasFaturas: colunasMongoFaturas
      })

      setColunas(columnsCopy)
    }
  }

  useEffect(() => {
    encodeURIComponent(decryptJWT('email'))
    async function checarFiltros() {
      despacho(mudarManejador('dspDispositivos'))
      const bloqueioFinanceiro = await api_gateway.get(
        '/m1/consultar/cliente_bloqueio?cd_pav_cliente=' +
          decryptJWT('codigoCliente') +
          '&fl_acao=1'
      )
      if (bloqueioFinanceiro.data.dados.length > 0) {
        verificadorBloqueioFinanceiro = true
        despacho(esconderMenuAcoesDispositivosBloqueio(true))
      } else {
        verificadorBloqueioFinanceiro = false
        despacho(esconderMenuAcoesDispositivosBloqueio(false))
      }

      const cicloAtual = await api_gateway
        .get('/m1/consultar/ciclo?dt_data=' + dataFormatada)
        .then(async function (resposta) {
          return resposta.data.dados[0]
        })
      await api_gateway
        .get(
          '/m1/servicos/token/buscar_colunas_simcard?email=' +
            encodeURIComponent(decryptJWT('email'))
        )
        .then(async function (resposta) {
          let colunasFaturas = resposta.data.dados.colunasFaturas
          setColunasMongoFaturas(colunasFaturas)
          colunaSimcard = resposta.data.dados.colunas

          const colunasPersonalizada = await api_gateway.get(
            '/m1/consultar/informacoes_adicionais_customizadas_cliente?cd_pav_cliente=' +
              decryptJWT('codigoCliente')
          )

          const dadosColunasPersonalizadas = colunasPersonalizada?.data?.dados

          if (
            colunaSimcard &&
            colunasPersonalizada &&
            colunasPersonalizada.data.status == 200 &&
            colunaSimcard.length > 0 &&
            dadosColunasPersonalizadas.length > 0
          ) {
            colunaSimcard = colunaSimcard?.map((col) => {
              if (
                [
                  'IAC_DESCRICAO_1',
                  'IAC_DESCRICAO_2',
                  'IAC_DESCRICAO_3'
                ].includes(col?.id)
              ) {
                const idx = col.id.substring(14) - 1
                return { ...col, nome: dadosColunasPersonalizadas[idx].TITULO }
              } else {
                return col
              }
            })

            await api_gateway.post(
              '/m1/servicos/dados/alterar_colunas_simcard',
              {
                email: decryptJWT('email'),
                colunas: colunaSimcard,
                colunasFaturas: colunasFaturas
              }
            )
          }
          setColunasMongo(colunaSimcard)

          const colunasTemporario = getColunasTemporario({
            colunaSimcard,
            verificadorBloqueioFinanceiro,
            cicloAtual
          })
          let ordenacaoColunas = []

          await Promise.all(
            colunasTemporario.map((item_colunasTemporario) => {
              colunaSimcard.map((item_colunaSimcard) => {
                if (item_colunaSimcard.id == item_colunasTemporario.dataField) {
                  item_colunasTemporario['ordem'] = item_colunaSimcard.ordem
                  ordenacaoColunas.push(item_colunasTemporario)
                }
              })
            })
          )
          ordenacaoColunas.sort(function (a, b) {
            return a.ordem - b.ordem
          })

          const hasPrivate = decryptJWT('userHasPrivateNetworks')
          if (hasPrivate) {
            ordenacaoColunas = ordenacaoColunas.map((coluna) =>
              coluna.dataField === 'VALOR_PLANO'
                ? { ...coluna, hidden: true }
                : coluna
            )
          }

          setColunas(ordenacaoColunas)
          return resposta.data.dados
        })
    }

    function getColunasTemporario({
      colunaSimcard,
      verificadorBloqueioFinanceiro,
      cicloAtual
    }) {
      const verificarColuna = (id) => verificarColunaDsp(colunaSimcard, id)

      const verificarNome = (id) => verificarNomeDsp(colunaSimcard, id)

      const isClienteBloqueadoOuLinhaInativa = (row) =>
        verificadorBloqueioFinanceiro || row?.TRAFEGO != 'Ativo'

      const colunasInicial = [
        {
          dataField: 'CALLERID',
          nome: 'Linha',
          formatter: (cell, row) => {
            if (cell === null || cell === undefined || cell === '') {
              return (
                <p
                  className={
                    isClienteBloqueadoOuLinhaInativa(row)
                      ? 'fonte-cor-7 label-tabela-1'
                      : 'fonte-cor-1 label-tabela-1'
                  }
                  key={row.FAT_CD_SIMCARD}
                >
                  {row.FULLCALLERID}
                </p>
              )
            } else {
              return <ContainerFormatter valor={cell} row={row} />
            }
          }
        },
        { dataField: 'ICCID', nome: 'ICCID' },
        { dataField: 'OPERADORA', nome: 'Operadora' },
        { dataField: 'REDE', nome: 'Rede' },
        {
          dataField: 'ON_OFF',
          nome: 'Status',
          formatter: (cell, row) => {
            const valorStatus = cell && cell.toLowerCase()
            if (valorStatus === 'online') {
              const dataInicioString = normalizarValorNull(row.INICIO)
              let dataInicioFormatada = '-'
              if (dataInicioString) {
                const dataInicio = parse(dataInicioString, 'yyyy-MM-dd HH:mm:ss', new Date())
                if (isValid(dataInicio)) {
                  dataInicioFormatada = format(dataInicio, 'dd/MM/yyyy HH:mm:ss')
                }
              }
              const divContent = (
                <div
                  className={
                    isClienteBloqueadoOuLinhaInativa(row)
                      ? 'fonte-cor-7 label-tabela-1 label-tabela-tooltip'
                      : 'fonte-cor-1 label-tabela-1 label-tabela-tooltip'
                  }
                  key={row.CD_SIMCARD}
                >
                  <Image className="img-eclipse-status" src={elipseVerde()} />{' '}
                  Online
                </div>
              )
              return dataInicioFormatada !== '-' ? (
                <CustomTooltip text={`Inicio - ${dataInicioFormatada}`}>
                  {divContent}
                </CustomTooltip>
              ) : (
                divContent
              )
            } else if (valorStatus === 'offline') {
              const dataFimString = normalizarValorNull(row.FIM)
              let dataFimFormatada = '-'
              if (dataFimString) {
                const dataFim = parse(dataFimString, 'yyyy-MM-dd HH:mm:ss', new Date())
                if (isValid(dataFim)) {
                  dataFimFormatada = format(dataFim, 'dd/MM/yyyy HH:mm:ss')
                }
              }
              const divContent = (
                <div
                  className={
                    isClienteBloqueadoOuLinhaInativa(row)
                      ? 'fonte-cor-7 label-tabela-1 label-tabela-tooltip'
                      : 'fonte-cor-1 label-tabela-1 label-tabela-tooltip'
                  }
                  key={row.CD_SIMCARD}
                >
                  <Image
                    className="img-eclipse-status"
                    src={elipseVermelho()}
                  />{' '}
                  Offline
                </div>
              )
              return dataFimFormatada !== '-' ? (
                <CustomTooltip text={`Fim - ${dataFimFormatada}`}>
                  {divContent}
                </CustomTooltip>
              ) : (
                divContent
              )
            } else if (valorStatus === 'estoque') {
              return (
                <CustomTooltip text="Estoque">
                  <div
                    className={
                      isClienteBloqueadoOuLinhaInativa(row)
                        ? 'fonte-cor-7 label-tabela-1 label-tabela-tooltip'
                        : 'fonte-cor-1 label-tabela-1 label-tabela-tooltip'
                    }
                    key={row.CD_SIMCARD}
                  >
                    <Image className="img-eclipse-status" src={elipseAzul()} />{' '}
                    Estoque
                  </div>
                </CustomTooltip>
              )
            }
          }
        },
        {
          dataField: 'ULTIMO_EVENTO',
          nome: 'Último Evento',
          formatter: (cell, row) => {
            return formatarData(
              cell,
              false,
              isClienteBloqueadoOuLinhaInativa(row)
            )
          }
        },
        {
          dataField: 'CONECTOU',
          nome: 'Início da última conexão',
          formatter: (cell, row) => {
            const dataInicioString = normalizarValorNull(row.INICIO)
            return formatarData(
              dataInicioString,
              false,
              isClienteBloqueadoOuLinhaInativa(row)
            )
          }
        },
        {
          dataField: 'DESCONECTOU',
          nome: 'Fim da última conexão',
          formatter: (cell, row) => {
            const dataFimString = normalizarValorNull(row.FIM)
            return formatarData(
              dataFimString,
              false,
              isClienteBloqueadoOuLinhaInativa(row)
            )
          }
        },
        {
          dataField: 'TEMPO_DURACAO',
          nome: 'Tempo da conexão',
          formatter: (cell, row) => {
            const calculaTempoDuracao = (dataFimString, dataInicioString) => {
              const dataFim = parse(dataFimString, 'yyyy-MM-dd HH:mm:ss', new Date())
              const dataInicio = parse(dataInicioString, 'yyyy-MM-dd HH:mm:ss', new Date())

              if (!isValid(dataFim) || !isValid(dataInicio)) {
                return '-'
              }

              const horasTotais = differenceInHours(dataFim, dataInicio)

              if (horasTotais < 0) {
                return '-'
              }

              const minutosTotais = differenceInMinutes(dataFim, dataInicio)
              const minutos = minutosTotais % 60
              const segundosTotais = differenceInSeconds(dataFim, dataInicio)
              const segundos = segundosTotais % 60

              const horasFormatadas = horasTotais < 10 ? '0' + horasTotais : horasTotais.toString()
              const minutosFormatados = minutos < 10 ? '0' + minutos : minutos.toString()
              const segundosFormatados = segundos < 10 ? '0' + segundos : segundos.toString()

              return `${horasFormatadas}:${minutosFormatados}:${segundosFormatados}`
            }

            let TEMPO_DURACAO = '-'
            const dataInicioString = normalizarValorNull(row.INICIO)
            const dataFimString = normalizarValorNull(row.FIM)

            if (isValidValue(dataInicioString)) {
              if (isValidValue(dataFimString)) {
                const dataFim = parse(dataFimString, 'yyyy-MM-dd HH:mm:ss', new Date())
                if (isValid(dataFim)) {
                  TEMPO_DURACAO = calculaTempoDuracao(dataFimString, dataInicioString)
                }
              } else {
                if (row.ON_OFF === 'Offline') {
                  TEMPO_DURACAO = '-'
                } else {
                  const dataAtualString = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
                  TEMPO_DURACAO = calculaTempoDuracao(dataAtualString, dataInicioString)
                }
              }
            }
            return (
              <p
                className={
                  verificadorBloqueioFinanceiro
                    ? 'fonte-cor-7 label-tabela-1'
                    : 'fonte-cor-1 label-tabela-1'
                }
              >
                {TEMPO_DURACAO}
              </p>
            )
          }
        },
        {
          dataField: 'TECNOLOGIA', nome: 'Tecnologia',
          formatter: (cell, row) => {
            const tecnologia = cell === 'NAO INFORMADO' ? 'Não informado' : cell
            return (
              <ContainerFormatter
                valor={tecnologia || '-'}
                row={row}
              />
            )
          }
        },
        { dataField: 'TRAFEGO', nome: 'Tráfego' },
        {
          dataField: 'PLANO',
          nome: 'Plano',
          formatter: (cell, row) => {
            const safeRow = typeof row === 'object' ? row : {}
            const safeCell = typeof cell === 'number' ? cell : 0

            const excedente =
              safeRow.EXCEDENTE > 0 ? '+ ' + safeRow.EXCEDENTE : ''

            return (
              <ContainerFormatter
                valor={`${safeCell.toFixed(2)} ${excedente} MB`}
                row={safeRow}
              />
            )
          }
        },
        {
          dataField: 'CONSUMO_PERCENTUAL',
          nome: 'Consumo (%)',
          formatter: (cell, row) => {
            let styleProgressBar = ''
            if (!cell || cell == '') cell = 0

            if (cell > cicloAtual.perc_dias_ciclo) {
              styleProgressBar = '#CD2D37'
            } else {
              styleProgressBar = '#36D896'
            }

            return (
              <ProgressBar className="barra-progresso-container">
                <ProgressBar
                  style={{ backgroundColor: styleProgressBar }}
                  now={cell}
                />
                <SpanSemIsChild
                  className={
                    isClienteBloqueadoOuLinhaInativa(row)
                      ? 'texto-barra-progresso fonte-cor-1'
                      : 'texto-barra-progresso fonte-cor-1'
                  }
                >
                  {cell === undefined ? '0.00%' : cell.toFixed(0) + '%'}
                </SpanSemIsChild>
              </ProgressBar>
            )
          }
        },
        {
          dataField: 'SALDO_MB',
          nome: 'Saldo',
          formatter: (cell, row) => {
            const excedente = row?.EXCEDENTE > 0 ? parseFloat(row.EXCEDENTE) : 0
            return (
              <ContainerFormatter
                valor={`${cell === null || cell === undefined || isNaN(cell)
                  ? '0.00'
                  : (parseFloat(cell.toFixed(2)) + excedente).toFixed(2)
                  } MB`}
                row={row}
              />
            )
          }
        },
        {
          dataField: 'CONSUMO_MB',
          nome: 'Consumo',
          formatter: (cell, row) => {
            return (
              <ContainerFormatter
                valor={
                  cell != undefined /*  && isNaN(cell) */
                    ? cell.toFixed(2) + ' MB'
                    : '-'
                }
                row={row}
              />
            )
          }
        },
        {
          dataField: 'SMS_ATIVADO',
          nome: 'Envio de SMS',
          formatter: (cell, row) => {
            if (cell == 0) {
              return <ContainerFormatter valor="Bloqueado" row={row} />
            } else {
              return (
                <p
                  className={
                    verificadorBloqueioFinanceiro
                      ? 'fonte-cor-7 label-tabela-1'
                      : 'fonte-cor-1 label-tabela-1'
                  }
                >
                  Ativo
                </p>
              )
            }
          }
        },
        { dataField: 'IMEI_VERIFICADOR', nome: 'IMEI' },
        { dataField: 'IA_MODELO_DISPOSITIVO', nome: 'Modelo' },
        { dataField: 'IA_MARCA_DISPOSITIVO', nome: 'Marca' },
        { dataField: 'NOME_GRUPO', nome: 'Grupo' },
        { dataField: 'IA_NOME', nome: 'Nome' },
        { dataField: 'DIAS_USADOS', nome: 'Dias utilizados' },
        { dataField: 'IA_MODELO_IMEI', nome: 'Modelo modem' },
        { dataField: 'IA_MARCA_IMEI', nome: 'Marca modem' },
        { dataField: 'IA_ENDERECO', nome: 'Endereço' },
        { dataField: 'IA_CIDADE', nome: 'Cidade' },
        { dataField: 'IA_UF', nome: 'Estado' },
        { dataField: 'IA_CEP', nome: 'CEP' },
        { dataField: 'CLIENTE_CODIGO', nome: 'Cliente' },
        { dataField: 'CLIENTE_NOME', nome: 'Nome do cliente' },
        { dataField: 'IP', nome: 'IP' },
        { dataField: 'IMSI', nome: 'IMSI' },
        {
          dataField: 'NUMPACOTES',
          nome: 'Pacotes no ciclo',
          usaFormatarMilhar: true
        },
        {
          dataField: 'CONEXOES_DIA',
          nome: 'Conexão no dia',
          usaFormatarMilhar: true
        },
        {
          dataField: 'PACOTES_DIA',
          nome: 'Pacotes no dia',
          usaFormatarMilhar: true
        },
        { dataField: 'FAT_CONTA', nome: 'Conta' },
        { dataField: 'FAT_CICLOVIDA', nome: 'Ciclo de vida' },
        { dataField: 'FAT_PLANO', nome: 'Nome do plano' },
        { dataField: 'FAT_NOTA_FISCAL', nome: 'Nota Fiscal' },
        { dataField: 'IAC_DESCRICAO_1' },
        { dataField: 'IAC_DESCRICAO_2' },
        { dataField: 'IAC_DESCRICAO_3' },
        { dataField: 'FAT_PEDIDO', nome: 'Pedido' },
        { dataField: 'PLANO_TIPO', nome: 'Plano tipo' },
        { dataField: 'SERVICO_ADICIONAL', nome: 'Tipo de produto' },
        { dataField: 'TIPO_SIMCARD', nome: 'Tipo de SIM card' },
        {
          dataField: 'SITUACAO',
          nome: 'Contrato'
        },
        {
          dataField: 'CONSUMO_DIA_MB',
          nome: 'Consumo no dia',
          formatter: (cell, row) => {
            return (
              <ContainerFormatter
                valor={cell ? cell.toFixed(2) + ' MB' : '-'}
                row={row}
              />
            )
          }
        },
        {
          dataField: 'DATA_ATIVACAO',
          nome: 'Ativação',
          formatter: (cell, row) => {
            return formatarData(
              cell,
              true,
              isClienteBloqueadoOuLinhaInativa(row)
            )
          }
        },
        {
          dataField: 'DATA_PRAZO_CONTRATO',
          nome: 'Prazo contrato',
          formatter: (cell, row) => {
            return formatarData(
              cell,
              true,
              isClienteBloqueadoOuLinhaInativa(row)
            )
          }
        },
        {
          dataField: 'DATA_COMPRA',
          nome: 'Aquisição',
          formatter: (cell, row) => {
            return formatarData(
              cell,
              true,
              isClienteBloqueadoOuLinhaInativa(row)
            )
          }
        },

        {
          dataField: 'SITUACAO_GRUPO',
          nome: 'Situação',
          formatter: (cell, row) => {
            return (
              <ContainerFormatter
                valor={cell ? cell.split(';')[0] : '-'}
                row={row}
              />
            )
          }
        },
        { dataField: 'IA_OBSERVACOES', nome: 'Informações adicionais' },
        { dataField: 'NUMCONEXOES', nome: 'Conexão no ciclo' },
        {
          dataField: 'FAT_N2_VALOR_PLANO',
          nome: 'Valor fatura',
          formatter: MoneyFormatter
        },
        {
          dataField: 'VALOR_PLANO',
          nome: 'Valor',
          formatter: MoneyFormatter
        }
      ]

      let colunasDsp = getColunasClienteNivelN3(colunasInicial, 'dataField')

      if (!isPortal()) {
        colunasDsp = [...colunasInicial]
      }

      return colunasDsp.map(
        ({ dataField, nome, formatter, usaFormatarMilhar }) => {
          let headerClasses = 'nao-selecionavel'
          let nomeColuna = nome

          if (
            ['IAC_DESCRICAO_1', 'IAC_DESCRICAO_2', 'IAC_DESCRICAO_3'].includes(
              dataField
            )
          ) {
            headerClasses = undefined
            nomeColuna = verificarNome(dataField)
          }

          let buttonOnClick = () => {
            if (dataField === 'TEMPO_DURACAO') return
            if (dataField && decryptJWT('codigoCliente') == 1) {
              return
            }
            let ordenarPor = dataField
            switch (dataField) {
              case 'SITUACAO':
                ordenarPor = 'Contrato'
                break
              case 'ON_OFF':
                ordenarPor = 'STATUS'
                break
              case 'SITUACAO_GRUPO':
                ordenarPor = 'SITUACAO'
                break
              case 'IMEI_VERIFICADOR':
                ordenarPor = 'IMEI'
                break
            }
            return handlerOrdenador(ordenarPor, ordenarPor)
          }

          let hidden = !verificarColuna(dataField)

          if (
            dataField === 'LAT_LONG_OPERADORA' ||
            (colunasPermissaoFaturas.includes(dataField) && !permissaoFaturas)
          ) {
            hidden = true
          }

          if (!formatter) {
            formatter = (cell, row) => {
              let valor = !isValidValue(cell) ? '-' : cell
              if (cell && usaFormatarMilhar) {
                valor = formatarMilhar(cell)
              }

              return <ContainerFormatter row={row} valor={valor} />
            }
          }

          return {
            dataField,
            headerClasses,
            text: (
              <button
                className="btn-header-nome fonte-cor-1"
                onClick={buttonOnClick}
              >
                {nomeColuna}
                <Image
                  id={dataField + dataField}
                  className="d-none"
                  src={setaDropdown()}
                />
              </button>
            ),
            hidden,
            formatter
          }
        }
      )
    }

    checarFiltros()
  }, [render, permissaoFaturas])

  return (
    <>
      {colunas.length !== 0 && (
        <TabelaSimcard
          onDragEnd={onDragEnd}
          colunas={colunas}
          render={render}
          setRender={setRender}
          conteudoBusca={props.conteudoBusca}
          filtros={props.filtros}
          buscaArquivo={props.buscaArquivo}
          ordenador={props.ordenador}
        />
      )}
    </>
  )
}

const colunasPermissaoFaturas = [
  'FAT_CONTA',
  'FAT_CICLOVIDA',
  'FAT_PLANO',
  'FAT_PEDIDO',
  'FAT_NOTA_FISCAL',
  'FAT_N2_VALOR_PLANO'
]

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros,
    buscaArquivo: state.buscaArquivoState.buscaArquivo,
    ordenador: state.manejadorState.ordenador
  }
}

export default connect(mapStateToProps)(React.memo(CarregarColunas))
